export const common = {
  请求延时: "Request delay",
  操作成功: "Success",
  暂无数据: "No Data",
  请输入: "Please enter",
  copyok: "copy success",
  copyerror: "copy failed",
};
// header: {},
// footer: {},

export const tableList = {
  '跟单交易量':'Trade volume',
  '跟单总交易量':'Trade total volume',
  持仓: "Positions",
  仓位: "Positions",
  当前委托: "Open Orders",
  当前计划: "Trigger Orders",
  历史仓位: "Order History",
  账单: "financial records",
  全部平仓: "All Liquidation",
  全部撤单: "Cancel all orders",
  用户昵称: "User Nickname",
  合约名称: "Name",
  创建时间: "Creation",
  方向: "Side",
  杠杆: "Leverage",
  保证金: "Margin",
  开仓价格: "Open Price",
  开仓均价: "Average open",
  全仓风险率: "Cross Risk Rate",
  预估爆仓价: "Liquidation Price",
  收益率: "Rate of Return",
  平仓价格: "Close Price",
  预计强平价: "Liquidation Price",
  持仓数量: "Size",
  张: "Cont",
  风险率: "Risk Rate",
  保证金率: "Margin ratio",
  预计止盈价: "Take Profit Price",
  预计止损价: "Stop Loss Price",
  浮动盈亏: "Floating P/L",
  平仓盈亏: "Realized P/L",
  盈亏: "P/L",
  委托数量: "Size",
  委托价格: "Order Price",
  成交价格: "Executed Price",
  成交均价: "Ave. Fill Price",
  止盈价: "Take Profit Price",
  止损价: "Stop Loss Price",
  执行价: "Executed Price",
  触发条件: "Trigger Price",
  操作: "Operation",
  手续费: "Fee",
  平仓类型: "Type",
  类型: "Type",
  数量: "Size",

  逐仓做多: "Isolated  Long",
  逐仓做空: "Isolated Short",
  全仓做多: "Cross Long",
  全仓做空: "Cross Short",
  永续合约: "Perpetual",

  手动平仓: "Manual Liquidation",
  市价平仓: "Market Close",
  限价平仓: "Limit Close",
  止盈: "Take Profit",
  止损: "Stop Loss",
  手动撤销: "Manual Undo",
  自动减仓: "ADL",
  强制减仓: "Forced lightening",
  强制平仓: "Forced Liquidation",
  资金不足系统撤单: "Insufficient Funds System Cancel",
  资金超限系统撤单: "Exceeded Funds SYstem Cancel",
  撤单: "Cancel",
  平仓: "Liquidation",
  更多: "More",
  部分平仓: "Partial Liquidation",
  反向开仓: "Reverse Opening",
  加仓: "Add",
  一键平仓: "Liquidate",
  最新价: "Latest Price",
  体验金平仓: "24-hour closing",
  下单时间: "Order Time",
  交易类型: "Trade Type",
  委托类型: "Order type",
  成交类型: "Deal Type",
  逐仓平多: "Isolated Close Long",
  逐仓开多: "Isolated Open Long",
  逐仓平空: "Isolated Close Short",
  逐仓开空: "Isolated Open Short",
  全仓平多: "Cross Close Long",
  全仓开多: "Cross Open Long",
  全仓平空: "Cross Close Short",
  全仓开空: "Cross Open Short",
  可平量为0: "0 to be Liquidated",
  激活价格: "Activate Price",
  状态: "Status",
  未激活: "Inactive",
  已激活: "Activated",
  回调率: "Recall Rate",
  仓位ID: "Position ID",
};
export const dialog = {
  前往设置: "Go to settings",
  提示: "prompt",
  确定: "Confirm",
  取消: "Cancel",
  确认要全部平仓吗:
    "Please confirm whether you want to close all positions at the market price and cancel all orders?",
  确认要全部撤单吗: "Are you sure you want to cancel all orders?",
  确认要一键平仓吗: "Are you sure you want to close all positions?",
  确认要一键平仓:
    "Are you sure you want to close all positions and cancel the relationship with the order?",
  确认要市价平仓吗:
    "Are you sure you want to close the position at the market price?",
  确认要限价平仓吗:
    "Are you sure you want to close the position at the limit price?",
  需先设置总跟单账户:
    "You need to set up the general documentary account before you can open the documentary.",
  需全部平仓后可重新设置:
    "When holding a documentary position, the amount and ratio of the documentary cannot be modified, and it can be reset after all positions are closed",
  加仓: "Add",
  不能为空: "Cannot be empty",
  必须为数字值: "Enter a numeric value",
  数字不能小于等于0: "It cannot be less than or equal to 0",
  请输入正确的杠杆倍数: "Please enter the correct leverage multiples",
  无法切换仓位模式: "Cannot switch position mode",
  当前账户没有权限: "The account has no permissions",
  swap001: "There is a position holded, so you cannot switch the mode",

  按张数: "By cont",
  按金额: "By amount",
  按比例: "By pro-rata",
  按价格: "By price",
  张: "Cont",
  预计加仓金额: "Est. add amount",
  预计加仓张数: "Est. cont to add",
  持仓数量: "Holding amount",
  开仓价格: "Open Price",
  确认要反向开仓吗: "Are you sure you want to open a reverse position?",
  预计平仓金额: "Liquidation Amount",
  预计平仓比例: "Liquidation Ratio",
  预计平仓张数: "Est. cont to close",
  比例不可以大于: "Ratio cannot be greater than",
  比例不可以小于: "Ratio cannot be less than",
  部分平仓: "Partial Liquidation",
  确认撤单吗: "Are you sure to cancel the order？",
  确认要平仓吗: "Are you sure you want to close the position?",
  盈亏: "P/L",
  当前止损价: "Current Price",
  预估止损价: "Stop Loss Price",
  亏损: "Loss",
  止损修改: "Stop Loss Modification",
  止损比例: "Stop Loss Ratio",
  止损价格: "Stop Loss Price",
  当前盈利价: "Take profit price",
  预估止盈价: "Take Profit Price",
  收益: "Profit",
  止盈修改: "Take Profit Modification",
  止盈比例: "Take Profit Ratio",
  止盈价格: "Take Profit Price",
  请输入加仓数: "Please enter the amount",
  请输入金额: "Please enter amount",
  请输入止盈价格: "Please enter the take profit price",
  请输入止盈比例: "Please enter the take profit ratio",
  请输入止损价格: "Please enter the stop loss price",
  请输入止损比例: "Please enter the stop loss ratio",

  "BTC/USDT账户模式": "BTC/USDT account mode",
  账户模式: "account mode",
  调整仓位模式: "Position Mode",
  保证金模式: "Margin",
  仓位模式: "Position",
  调整保证金模式:
    "Adjusting the margin mode takes effect for all USDT contracts",
  调整仓位合并模式:
    "Adjusting the position mode takes effect for all USDT contracts",
  全仓模式: "Cross Mode",
  仓位合并: "Adjustment",
  逐仓: "Isolated",
  全仓: "Cross",
  合仓: "Merge",
  分仓: "Split",
  swap002:
    "In the isolated mode, users can hold positions in both directions, and the risks of short and long are calculated independently. The forced liquidation will only cause the lose of position margin. When the user actively closes the position, the loss and profit generated by the short and the long positions respectively will be immediately settled into the position margin of the corresponding position.",
  全仓模式下所有仓位将共享合约账户的可用保证金:
    "In the cross mode, all positions will share the available of the contract account. If a liquidation occurs, all positions and available may be lost. Please pay attention to the risk of holding positions!",
  合仓提示: "",
  分仓提示: "",
  不再提示: "No prompt again",

  biking合约用户使用协议: "biking Contract User Agreement",
  综述:
    "<b>1.综述</b><br><br>" +
    "<span>" +
    "1.1永续合约(“本服务”)是“biking”推出的虚拟资产衍生品。由“biking”负责产品的设计管理和交易平台的运营服务。" +
    "为使用“biking”永续合约，您应当阅读并遵守《“biking”永续合约用户使用协议》(“本协议”)。请您务必审慎阅读、充分理解各条款内容，并选择接受或不接受本协议。" +
    "<br><br>" +
    "1.2除非您已阅读并接受本协议所有条款，否则您无权使用“biking”永续合约及其相应的服务。您接受本协议的行为，以及您使用本服务的行为即视为您已阅读并同意受本协议的约束。" +
    "</span>" +
    "<br><br>" +
    "<b>2. 使用本服务的资格</b>" +
    "<br><br>" +
    "<span>2.1 您了解并确认：" +
    "<br>" +
    "您已同意遵守“biking服务条款”，同时您有资格并且不被禁止使用其中定义的“服务”;" +
    "<br>" +
    "本协议与您所在国家或地区的法律没有冲突;" +
    "<br>" +
    "您是存入本服务的虚拟资产的合法所有者，并保证这些虚拟资产的来源是合法的。" +
    "<br><br>" +
    "2.2您了解使用本服务的风险，包括但不限于：" +
    "<br>" +
    "虚拟资产及其衍生品的高价格波动可能会在短时间内造成重大或全部损失；" +
    "</span>",
  我已阅读并同意上述协议: "I have read and agree to the above agreement",

  调整杠杆: "Adjust leverage",
  杠杆倍数: "Leverage",
  当前杠杆倍数最大可开: "The max leverage can be opened：",
  "当前仓位所需保证金：": "Margin required for the position：",

  交易单位切换: "Switch unit",
  成交类型切换: "Switch type",
  限价: "Limit",
  市价: "Price",
  数字范围必须在: "The number ranges from 1 to 100",
  请输入平仓数: "Please enter the liquidation quantity",
  请输入平仓比例: "Please enter the liquidation ratio",
  请输入整数: "Please enter an integer",
  以当前最优价格交易: "Trade at the current best price",
  请输入格式正确的杠杆倍数: "Please enter the leverage multiple in format",
  杠杆倍数提示: "The leverage is too high, please pay attention to the risks",
  下单二次确认: "Order Double-check",
  平仓二次确认: "平仓二次确认",
  下单确认: "Order Confirmation",
  二次确认不展示: "No prompt (you can turn it on in ‘Preferences’",
  切换交易单位: "Trading Unit",
  偏好设置: "Preferences",
  仓位止盈止损: "Take Profit/Stop Loss",
  移动止盈止损: "Trailing Profit/Loss",
  止盈止损提示:
    "Moving Stop Loss and Take Profit is used for position closing, which refers to the strategy of traders moving the pre-set order in order to protect the profits when the market is falling from a rise trend. When the latest market price reaches the set price, the order will be activated; when the market price reaches (1 ± correction) of the highest (lowest) price, the trade will be triggered, and the execution price will be (1 ± correction) of the highest (lowest) price",
  最新成交价: "Latest Price",
  设置止盈: "Set Take Pofit",
  设置止损: "Set Stop Loss",
  预计盈利: "Est. Profit",
  预计亏损: "Est. Loss",
  调整保证金: "Adjust Margin",
  增加: "Add",
  减少: "Reduce",
  最大: "Max",
  当前仓位保证金: "Current Margin",
  最大可增加: "Max to Add",
  最大可减少: "Max to Reduce",
  调整后参考强评价: "Est. Liquidation Price",
  请输入保证金: "Please enter margin",
  强平价格: "Liquidation Price",
  开仓数量: "Open Quantity",
  计算: "Calculate",
  计算结果: "*For reference only",
  回调率: "Recall Rate",
  请输入回调率: "Please enter the recall rate",
  仓位数量: "Position Qty.",
  激活价: "Activate Price",
  请输入激活价: "Please enter the activate price",
  激活做多提示: "Long needs to be higher than the latest trade price",
  激活做空提示: "Short needs to be lower than the latest trade price",
};
export const codeInfo = {
  永续合约: "Perpetural",
  标记价格: "Mark Price",
  指数价格: "Index Price",
  指数价格提示:
    "The real-time index price of the contract. This price will participate in the calculation of the estimated liquidation price of the user's position, and may deviate from the latest transaction price of the contract to avoid price manipulation.",
  "24H最高": "24H High",
  "24H最低": "24H Low",
  资金费率: "Funding",
  距费用结算: "Countdown",
  我的赠金: "My bonus",
};
export const panKou = {
  交易深度: "Order Book",
  实时成交: "Full Order Book",
  张: "Cont",
  保证金: "Margin",
  价格: "Price",
  数量: "Size",
  时间: "Time",
  累计: "Sum",
};
export const placeOrder = {
  立即去玩: "Go play",
  全仓: "Cross",
  逐仓: "Isolated",
  杠杆: "Leverage",
  开多: "Open long",
  开空: "Open short",
  市价委托: "Market",
  限价委托: "Limit",
  计划委托: "Trigger",
  价格: "Price",
  数量: "Size",
  限价: "Limit",
  市价: "Market Price",
  止盈止损: "Stop-Limit",
  张: "Cont",
  开仓价: "Price",
  触发价: "Trigger Price",
  执行价: "Order Price",

  收益: "Profit",
  按比例设置: "Set by pro-rata",
  按价格设置: "Set by price",
  亏损: "Loss",

  swap003: "Buy/Long",
  swap004: "Sell/Short",
  买入: "Buy",
  卖出: "Sell",
  做多: "Long",
  做空: "Short",
  可用: "Avail. Margin",
  可做多: "Go Long",
  可做空: "Go Short",

  资产: "Assets",
  持仓保证金: "Position Margin",
  未实现盈亏: "Unrealized P/L",
  净值: "Net Worth",
  可用保证金: "Avail. Margin",
  账户余额: "Account Balance",
  风险率: "Risk Rate",

  合约信息: "Info",
  指数来源: "Index Source",
  合约面值: "Contract Face Value",
  资金费率: "Funding Rate",
  最大杠杆: "Max Leverage",
  下单方向可开张数的: "Available cont can be opened for this order",

  立即注册: "Sign up",
  登录: "Log in",
  swap005: "Assets (Perpetual Swap)",
  登录以查看: "Log in to view",

  请输入数量: "please enter amount",
  请输入价格: "Please enter price",
  请输入限价: "Please enter limit",
  请输入止盈止损: "Please enter take profit and stop loss",
  "止损率不能大于90%": "Stop loss rate cannot be greater than 90%",
  止损价格不能大于: "Stop loss price cannot be greater than ",
  开通合约账号: "Open contract account",
  账号冻结: "Account in orders",
  "止盈率不能大于1000%": "Take Profit rate cannot be greater than 1000%",
  请输入触发价: "Please enter Amount",
  保证金: "Margin",
  体验金: "Bonus",
  不使用体验金: "Do not use bonus",
  查看详情: "View details",
  委托保证金: "Cost",
  币: "Coin",
  计算器: "calculator",
  划转: "transfer",
};
export const codelist = {
  搜索: "Search",
  全部: "All",
  交易对: "Trading Pair",
  最新价: "Latest Price",
  涨幅: "Rise Rate",
  自选: "Favourite",
  添加自选成功: "Add favorites",
  取消自选成功: "Cancel favorites",
};
export const merchandiser = {
  我的实盘: "My trading",
  与优秀的交易员共同赚钱: "Making Money Together with Excellent Traders",
  code_00051: "Copy Trading Community",
  个人中心: "Personal Center",
  更多服务: "More Service",
  钱包: "Wallet",
  衍生品: "Futures",
  跟单设置: "Set Follow",
  跟单: "Copy Trading",
  跟单提示: "Data is updated every hour",
  我的跟单: "My copy trading",
  成为交易员: "Become a trader",
  综合排名: "Overall Ranking",
  收益率: "yield",
  累计收益率: "Total Yield",
  近3周收益: "Yield in 3 weeks",
  近3周胜率: "Win rate in 3 weeks",
  总收益: "total earning",
  累计跟随人数: "Total followers",
  AUM: "AUM",
  当前跟谁: "Currently following",
  搜索交易员: "Search Trader",
  满员: "full",
  申请成为交易员: "Apply to become a trader",
  手机号: "Mobile number",
  邮箱: "Email",
  请输入邮箱: "Please enter your email",
  邮箱错误: "Please enter the correct email address",
  请输入手机号: "Please enter your phone number",
  手机号错误: "Please enter the correct mobile phone number",
  请输入正确数值: "Please enter the correct number",
  申请交易员提示文案:
    "Apply to become a copy trading trader, and you can get the profit from leading orders",
  跟单确认: "Documentary confirmation",
  我已同意跟单协议: "I have read and agreed to the documentary agreement",
  跟单协议: "《Documentary agreement》",
  申请跟单提示文案:
    "This agreement is concluded between you (hereinafter referred to as you or your) and the BiKing. By visiting, using or using any service provided by the platform or any website (wang. com), mobile application or other related services provided by the website of the platform or any affiliate (hereinafter collectively referred to as the service), you confirm that you have read We understand and accept all the terms and conditions stipulated in the Terms of Use Agreement (hereinafter referred to as the Terms of Use), as well as our privacy statement published on the platform. In addition, you may also need to abide by the additional terms and conditions applicable to some functions of this service.",
  申请跟单提示文案1:
    "1.There may be a risk of loss if you follow the trader to make an order. The risk shall be borne by the documentary user;",
  申请跟单提示文案2:
    "2.The BiKing platform supports the followers to use the warehouse by warehouse mode documentary account for documentary trading. If the followers need to open their positions independently, they can go to the contract to use the contract account for contract trading, and the documentary account will not be affected during this period.",
  申请跟单提示文案3:
    "3.After the following is successful, only the newly opened positions of the traders will be followed, and the positions already held will not be followed; You can cancel the tracking at any time. Cancelling the tracking will not close the position of the following orders. You can choose to close the position manually;",
  申请跟单提示文案4:
    "4.During the documentary period, adjusting the documentary position will cause you to leave the documentary mode;",
  申请跟单提示文案5:
    "5.Follow the traders to make profits after closing their positions. The order will be rewarded by 12% of the profit amount to the traders with orders.",
  申请跟单提示文案6:
    "6.There may be loss risk when placing orders with traders. Please choose carefully, pay attention to risk control and understand the risk of documentary",
  申请跟单提示文案7:
    "7.When the following trader's order is judged as illegal transaction and the trader's identity is cancelled, you will not be able to follow to open a new position, and the following position will not be affected, but will immediately leave the tracking mode.",
  申请跟单提示文案8:
    "8.The trader has the right to remove the tracking user. After being removed, you will not be able to follow to open new positions, and the positions already followed will not be affected.",
  搜索您的国家名或国家区号: "Search your country name or country code",
  我已同意成为交易员: "I have agreed to be a trader",
  请勾选: "Please tick",
  申请交易员失败提示:
    "You are currently copying, and you cannot apply to become a trader for now. Please stop all copying before applying.",
  我知道了: "I understand",
  今日收益: "Today's Earnings",
  累计收益: "Total Earnings",
  交易员分成: "Trader's share",
  待结算分成: "Pending settlement share",
  已结算分成: "Settled share",
  当前跟单: "Position",
  历史跟单: "History",
  我的交易员: "My trader",
  编辑: "Edit",
  平仓均价: "Average closing price",
  持仓均价: "Average position price",
  开仓时间: "Opening time",
  平仓时间: "Close time",
  预估暴仓价: "Estimated liquidation price",
  交易员: "Trader",
  详情: "Details",
  仓位ID: "Position ID",
  空位提醒: "Vacancy reminder",
  空位提醒内容:
    "The number of copying orders for this trader is full, and a reminder will be sent when it is not full",
  当前跟随: "Currently following",
  跟随人数数据: "{v1}/{v2}people",
  跟随人数: "Number of followers",
  总权益: "Total Equity",
  带单合约: "Leading orders contracts",
  交易数据: "Transaction data",
  交易笔数: "Number of transactions",
  盈利笔数: "Number of Profits",
  亏损笔数: "Number of losses",
  扛单比例: "carrying order ratio",
  平均扛单率: "Average carrying order rate",
  最大扛单率: "Maximum carry rate",
  订单: "Order",
  跟随者: "Follower",
  跟随中: "Following",
  跟随者收益: "Follower’s income",
  跟随用户: "Follow user",
  跟随总额: "Follow total amount",
  跟随收益: "Follow earning",
  交易员订单本金: "Trader's order principal",
  当前带单: "Current leading order",
  历史带单: "Leading order history",
  跟单数据统计: "Follow-up data statistics",
  不用了: "No need",
  设置提醒成功: "Set reminder successfully",
  我的带单: "My strategy bot",
  查看主页: "View home page",
  利润分成比例: "Profit share ratio",
  跟随交易员: "Follow Trader",
  仓位类型: "Position Type",
  指定杠杆: "Specified leverage",
  请输入杠杆: "Please enter leverage",
  单笔倍率: "Single Magnification",
  单笔金额: "Single Amount",
  固定额度: "Fixed Amount",
  请输入单笔金额1: "Please enter a fixed amount not less than 5U",
  请输入单笔金额: "Please enter the single copy amount {v1}～{v2}",
  请输入单笔倍率: "Please enter the copy ratio {v1}～{v2}",
  每次下单折合U:
    "Every time you open a position, invest a margin equivalent to {v1}USDT",
  每次下单倍数:
    "The number of orders placed each time is {v1} times the number of orders placed by the trader",
  倍率: "Magnification",
  跟单本金: "Copy order principal",
  总跟单保证金: "Total Margin",
  请输入跟单本金: "Please enter the copy trading principal",
  资产账户: "Asset account {v1}USDT",
  合约账户: "Swap Account{v1}USDT",
  风险控制: "Risk Control",
  设置: "Settings",
  保存: "save",
  取消跟随: "Cancel follow",
  移除跟随: "Remove",
  交易员保证金: "Trader margin",
  请输入交易员保证金: "Please enter the trader's margin",
  风险设置提示:
    "When the position principal of following this trader reaches this value, you will no longer follow the order",
  关闭带单: "Close strategy bot",
  我的跟随者: "my follower",
  带单设置: "strategy bot setting",
  预计利润分成: "Estimated profit share",
  利润分成: "Profit share",
  开启成功: "Open successfully",
  开启失败: "Failed to open",
  关闭成功: "Close successfully",
  关闭失败: "Failed to close",
  确认取消吗: "Are you sure to unfollow?",
  条件一: "The futures has no position, current order, trigger order",
  条件二: "Available balance of contract account>={v}USDT",
  条件三: "The futures has no position",
  最大回撤: "Maximum drawdown",
  平均持仓时间: "Average holding position time",
  正在跟随: "Following",
  历史跟随: "History follows",
  累计跟单: "Cumulative copy trading",
  累计分成: "Cumulative share",
  笔: "trade",
  上一页: "Previous page",
  下一页: "Next page",
  返回: "Return",
  今日预估收益: "Today's estimated earning",
  账户权益: "Account Equity",
  将账户权益展示在个人信息页面:
    "Display account equity on the personal information page",
  带单本金: "strategy bot principal",
  每次开仓均会展示带单本金:
    "Every time you open a position, the principal of strategy bot will be displayed",
  隐藏挂单价: "Hide pending order price",
  带单币对: "strategy bot pairs",
  入住时间: "Check-in time",
  保存成功: "Save successfully",
  取消成功: "Cancel successfully",
  设置成功: "Set successfully",
  跟单合约: "Copy order futures",
  历史委托: "Order history",
  成交数量: "Number of transactions",
  触发时间: "Trigger time",
  开启带单: "Open strategy bot",
  账户已冻结: "he account has been frozen, please contact customer service",
  审核中: "Under review",
  小时: "{v}hours",
  累计分润: "Cumulative profit",
  今日预估分润: "Today's estimated profit",
  交易协议: "《Transaction agreement》",
  带单协议: "《With a single agreement》",
  追加跟单本金: "Add principal",
  提示: "Prompt：",
  提示信息:
    "The profit will be settled at 0:00 every day and completed before 1:00. After settlement, it will be automatically distributed to your contract account; If you have a position with documents during the settlement period, the profit will be settled on the next trading day",
  合约跟单: "Contract Documentary",
  跟单文字: "Making money with top traders in the world at biking",
  查看牛人实盘: "View Bull Mans Firm Offer",
  捕捉市场信号: "Capture market signals",
  复制高手收益: "Copy Expert Benefits",
  跟单指南: "Documentary Guidelines",
  跟单广场: "Documentary Plaza",
  跟单总收益: "Total documentary income",
  丰厚分润收入: "Rich profit income",
  更多平台曝光: "More Platform Exposure",
  专属交易徽章: "Exclusive Trading Badge",
  成为Biking带单交易员: "Just one step, becoming a Biking order trader",
  享受Biking带单交易员的独家福利:
    "Enjoy the exclusive benefits of Biking order traders",
  平台奖励: "Enjoy 12% profit sharing with orders",
  联系方式: "Contact information",
  简介: "Introduction",
  请输入简介: "Please enter a brief introduction",
  交易能力证明: "Proof of trading ability (optional)",
  选择周期:
    "Please select screenshots of Yield curve and transaction data statistics with period>30 days; If you do not upload, we will default to reviewing your Ouyi transaction records. Up to 3 images can be uploaded, with each image size not exceeding 10 MB",
  我已阅读并同意: "I have read and agree",
  跟单交易服务条款: "《Documentary Trading Service Terms》",
  立即申请: "Apply Now",
  请输入联系方式: "Please enter contact information",
  联系方式不正确: "Incorrect contact information!",
  邮箱格式不正确: "Incorrect email format",
  请输入简介信息: "Please enter the introduction information",
  请确认勾选协议: "Please confirm to check the agreement",
  上传头像图片限制: "The size of uploaded avatar images cannot exceed 10MB!",
  最大限制: "The current maximum limit for uploading 3 files",
  带单交易员招募中:
    "Traders with orders are being recruited, and immediately enjoy 12% profit sharing with orders",
  跟单成功: "Successfully copy the order",
  昵称: "Nick name",
  请输入昵称: "Please enter a nickname",
  申请交易员已提交:
    "The trader application has been submitted, please wait for approval",
};
export const hyy = {
  bkt: "No",
  wqdkt: "Confirm",

  kt12: " 1. Before you participate, be sure to thoroughly understand the basic knowledge and related risks of digital currency contract transactions and the business rules related to participating in the derivatives transactions.",
  kt13: "  2. The risks mentioned above are only enumerative, and we fail to provide a detailed list of all risk factors related to digital asset derivatives trading. Investors should also seriously consider and accept other possible risks before investing in digital asset derivatives trading.",
  kt14: "3. We sincerely hope and advise investors to make a prudent decision on whether to participate in this contract transaction and rationally allocate their digital assets based on their own actual conditions such as risk tolerance.",

  kt0: "Dear user:",
  kt1: "You have not yet opened the contract account and granted contract trading permission, please read the following terms carefully before deciding whether to open:",
  kt2: "1. When you trade in the contract market, if the market price trend is against you and cause your position margin insufficient, BiKing perpetual contract will forced-liquidate your position according to the system agreement and disclose the details.",
  kt3: "2. You must read carefully and comply with the business rules of the BiKing perpetual contract, understand the mechanism and operating principle of the contract, and understand all risks of the market.",
  kt4: "4. BiKing perpetual contract is accessing to contract trading system. The gain and loss of the user's position changes with the fluctuation of contract market. When there’s big losses in the position, it will wipe out in the contract trading system. Users are requested to make their own timely trading behaviors according to the contract market, and they are responsible for their own gains and losses. Thus, BiKing does not assume any presumption or established guarantee responsibility.",
  kt5: "5. Under certain extreme market conditions, you may find it difficult or impossible to liquidate a position. This can occure, for example, when your profit ranks first in the effective leverage PnL across the contract market, and the opponent's position is insufficient for the insurance fund to cover its loss.",
  kt6: "6. Digital asset derivative transactions may face policy regulatory risks in a certain scope of Law. Before trading, you need to make a careful judgment on the premise of understanding the policy regulatory background of the transaction region. Due to changes in relevant national and regional laws, regulations, policies, amendments to contract exchange trading rules, and the introduction of emergency measures, BiKing will disclose the statement in advance. Your pending contracts may not continue to be held, but margin and profit balances will still be settled.",
  kt7: "7. The losses caused by part or whole failure to conclude transaction when the part or whole failure is due to reasons uncontrolled by BiKing, for example, earthquake, flood, fires, and other force majere, or malfunctions of computer or communication system are undertaken at your own.",
  kt8: "8. 'Hedging' transactions, like speculative transaction, are also subject to risks arising from price fluctuations.",

  kta9: "9. If you do not have real-name authentication or are not bound to Google verification, or lend your account to someone else, it may reduce the safety of your contract margin.",

  kta10:
    "3. Under certain extreme market conditions, you may find it difficult or impossible to liquidate a position. This can occure, for example, when your profit ranks first in the effective leverage PnL across the contract market, and the opponent's position is insufficient for the insurance fund to cover its loss.",

  kt9: "I have read the Risk Warning carefully and agree to take all the risks",
  kt10: "Open contract account and grant contract trading permission",
  zjhz: "Transfer",
  ljhz: "Transfer now",
  qx: "Cancel",
  khz: "Can be transfered",
  qxz: "Please choose",
  bz: "Currency",
  c: "from",
  zz: "to",
  sl: "Amount",
  qb: "All",
  ktcg: "Succeeded",
  ktsb: "Failed",
  hzcg: "Succeeded",
  hzsb: "Failed",
  wyyd: "", //未勾选已经阅读提示文案
  tc: "Sign out",
  warning1: "Please choose the currency",
  warning2: "Please enter transfer-out account",
  warning3: "Please enter transfer-in account",
  warning4: "Please enter the quantity that is less than the availale quantity",
  warning5: "Keep up to 4 decimal places",
  gb: "Close",
  openSuccess: "You confirmed Contract Trading",
  openSuccessTip: "Please transfer assets",
  not_get_nm:
    "Sorry, non-neg chips activity has been released. non-neg chips can not be obtained in this transfer",
};

export const invite = {
  ljzc: "Register Now",
};



// WEBPACK FOOTER //
// ./src/i18n/lang/merchandiser/en.js